import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Header from "go-app/components/Header";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { MessageEventContext } from "./services/context";
import { MessageEventApi, MessageEventResourceApi } from "./services/types";

interface Props {
	messageEvent: MessageEventApi;
}

const MessageEventPreview = (props: Props): JSX.Element => {
	const { t } = useTranslation();
	const messageEvent = props.messageEvent;
	const messageEventService = React.useContext(MessageEventContext);

	const getResourceUrl = (resourceType: string, entityId: string | number, resources: MessageEventResourceApi[]) => {
		const link = messageEventService.getResourceUrl(resourceType, entityId, resources);
		const title = messageEventService.getResourceTitle(resourceType);
		if (!link) return title;
		return (
			<Link to={link} target={"_blank"} rel={"noreferrer"}>
				{title}
			</Link>
		);
	};

	return (
		<div className="content">
			<Header
				title={`${t(
					"lib:go_component.message_events.preview.header.title"
				)} "${messageEventService.getMessageEventTypeTitle(messageEvent.type)}"`}
			/>
			<div className={"content-preview"}>
				<div className="row">
					<div className="col-md-8">
						<Card>
							<Card.Body>
								<h5>{t("lib:common.word.basic_data")}</h5>
								<dl className="mb-0">
									<dt>{t("lib:common.word.type")}</dt>
									<dd>{messageEventService.getMessageEventTypeTitle(messageEvent.type)}</dd>
								</dl>

								<dl className="mb-0">
									<dt>{t("lib:common.word.source")}</dt>
									<dd>{t(`lib:enums.message_events.source.${messageEvent.source}`)}</dd>
								</dl>

								<dl className="mb-0">
									<dt>{t("lib:common.word.created_at")}</dt>
									<dd>{FormatDate(messageEvent.created_at, undefined, true)}</dd>
								</dl>
								<dl className="mb-0">
									<dt>{t("lib:go_component.message_events.preview.username")}</dt>
									<dd>{messageEvent.username}</dd>
								</dl>
								<dl className="mb-0">
									<dt>{t("lib:common.word.description")}</dt>
									<dd>{messageEvent.description}</dd>
								</dl>
							</Card.Body>
						</Card>
					</div>
					<div className="col-md-4">
						{messageEvent.resources.length > 0 && (
							<Card>
								<Card.Body>
									<h5>{t("lib:go_component.message_events.preview.resources.title")}</h5>
									{messageEvent.resources.map((resource, index, resources) => {
										const resourceUrl = getResourceUrl(
											resource.resource_type,
											resource.entity_id || resource.resource_id,
											resources
										);
										return (
											<>
												{resourceUrl}
												{resourceUrl && index !== messageEvent.resources.length - 1 && <br />}
											</>
										);
									})}
								</Card.Body>
							</Card>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
export default MessageEventPreview;
